export default (data) => ({
    data: data,

    init() {
        window.dataLayer = window.dataLayer || [];

        this.$el.addEventListener('click', (e) => {
            this.sendEvent()
        })
    },

    async sendEvent() {
         await window.dataLayer.push({
            event : this.data.event,
            description : this.data.description
        });
    }
});
